import React, { useRef, useEffect, useState } from "react";
import "../styles/Hero.css";
import "../styles/GlobalStyles.css";

const Hero = () => {
  const sectionRef = useRef(null);
  const [docked, setDocked] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setDocked(!entry.isIntersecting),
      { threshold: 0, rootMargin: "-62px 0px 0px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      {/* Sticky Book Now bar */}
      <div
        style={{
          position: "fixed",
          top: "var(--nav-h, 62px)",
          left: 0,
          right: 0,
          zIndex: 9,
          background: "var(--dark, #2a2a2a)",
          padding: "10px 18px",
          display: "flex",
          justifyContent: "center",
          transform: docked ? "translateY(0)" : "translateY(-110%)",
          transition: "transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)",
          boxShadow: "0 2px 12px rgba(0,0,0,0.18)"
        }}
      >
        <a
          href="https://afterglobeautyco.square.site/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
          style={{ padding: "8px 32px", fontSize: "0.85rem" }}
        >
          Book Now
        </a>
      </div>
      <section className="hero" ref={sectionRef}>
        <img
          src="/courtbanner.jpg"
          alt=""
          className="hero-bg"
          aria-hidden="true"
        />
        <div className="hero-inner" style={{ position: "relative", zIndex: 1 }}>
          <img
            src="/afterglologo.png"
            alt="Afterglo Beautyco"
            className="hero-logo"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <p className="hero-tagline fadeInSequential">
            {"Meet me in the afterglo".split("").map((ch, i) => (
              <span key={i} style={{ animationDelay: `${0.04 * i}s` }}>
                {ch === " " ? "\u00A0" : ch}
              </span>
            ))}
          </p>
          <div className="hero-ctas">
            <a
              href="https://afterglobeautyco.square.site/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Book Now
            </a>
            <a
              href="/education"
              className="btn btn-outline"
              style={{
                borderColor: "#fff",
                color: "#fff",
                background: "rgba(255,255,255,0.12)"
              }}
            >
              Lash Education
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
